<div>
	<div class="top-margin" fxLayout="row" fxLayoutAlign="center center">
		<div class="primary-text font-size-13 font-weight-bold m-t-1" fxFlex="65" fxFlexOffset="10">
			Minimum Truck Count
		</div>
		<div fxFlex="25">
			<mat-form-field fxFlex="100">
				<input
					(input)="filterChanged()"
					[(ngModel)]="trucksCount"
					autocomplete="off"
					matInput
					type="number"
				/>
			</mat-form-field>
		</div>
	</div>
</div>
